// mutations
const RESTAURANT_PRODUCTS_ALL = (state, restaurantProducts) => {
  if (restaurantProducts.code === 1) {
    state.restaurantProducts = restaurantProducts.data
    state.status = 'success'
  } else {
    alert(restaurantProducts.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_FORM = (state, restaurantProducts) => {
  if (restaurantProducts.code === 1) {
    state.restaurantProducts = restaurantProducts.data
    state.status = 'success'
  } else {
    alert(restaurantProducts.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_SHOW = (state, restaurantProducts) => {
  if (restaurantProducts.code === 1) {
    state.restaurantProducts = restaurantProducts.data
    state.status = 'success'
  } else {
    alert(restaurantProducts.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_CREATE = (state, restaurantProducts) => {
  if (restaurantProducts.code === 1) {
    state.restaurantProducts = restaurantProducts.data
    state.status = 'success'
    //alert(restaurantProducts.message)
  } else {
    alert(restaurantProducts.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_UPDATE = (state, restaurantProducts) => {
  if (restaurantProducts.code === 1) {
    state.restaurantProducts = restaurantProducts.data
    state.status = 'success'
    alert(restaurantProducts.message)
  } else {
    alert(restaurantProducts.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_DELETE = (state, restaurantProducts) => {
  if (restaurantProducts.code === 1) {
    state.restaurantProducts = restaurantProducts.data
    state.status = 'success'
    alert(restaurantProducts.message)
  } else {
    alert(restaurantProducts.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_ADD = (state, restaurantProducts) => {
  if (restaurantProducts.code === 1) {
    state.restaurantProducts = restaurantProducts.data
    state.status = 'success'
    alert(restaurantProducts.message)
  } else {
    alert(restaurantProducts.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_MINUS = (state, restaurantProducts) => {
  if (restaurantProducts.code === 1) {
    state.restaurantProducts = restaurantProducts.data
    state.status = 'success'
    alert(restaurantProducts.message)
  } else {
    alert(restaurantProducts.message)
    state.status = 'error'
  }
}

export default {
  RESTAURANT_PRODUCTS_ALL,
  RESTAURANT_PRODUCTS_FORM,
  RESTAURANT_PRODUCTS_SHOW,
  RESTAURANT_PRODUCTS_CREATE,
  RESTAURANT_PRODUCTS_UPDATE,
  RESTAURANT_PRODUCTS_DELETE,
  RESTAURANT_PRODUCTS_ADD,
  RESTAURANT_PRODUCTS_MINUS
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/products/mutations.js